<template>
  <div class="menuBar">
    <div class="menuBarTitle">
      <img src="../assets/logo-bangkok-lotteries.png" alt="Busan Lotteries Logo" />
      Busan Lotteries
    </div>

    <div class="menuBarContainer">
      <router-link to="/home" class="menuBarContainerItem">
        <span v-if="this.langChosen === 'gr'">집</span>
        <span v-else>Home</span>
      </router-link>

      <router-link to="/results" class="menuBarContainerItem">
        <span v-if="this.langChosen === 'gr'">결과</span>
        <span v-else>Results</span>
      </router-link>

      <router-link to="/faq" class="menuBarContainerItem">
        <span v-if="this.langChosen === 'gr'">자주하는 질문</span>
        <span v-else>FAQ</span>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
.menuBar {
  display: none;
}

@media screen and (min-width: 768px) {
  .menuBarContainerItem.router-link-active {
    background-color: transparent;
    color: var(--bluePrim);
  }

  .menuBar {
    width: 100vw;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: var(--darkColor);
    padding: 2vh 3vw;
    box-sizing: border-box;
  }

  .menuBarTitle {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .menuBarTitle img {
    width: 5vw;
    margin-right: 1vw;
  }

  .menuBarTitle {
    font-size: 2em;
    font-weight: bold;
    color: var(--lightColor);
  }

  .menuBarContainerItem {
    text-decoration: none;
    padding: 1.4vh 1.3vw;
    border-radius: 5px;
    color: var(--lightColor);
  }

  .menuBarContainerItem.router-link-active:hover,
  .menuBarContainerItem:hover {
    background-color: var(--lightColor);
    color: var(--darkColor);
  }
}
</style>
